import { WidgetComponent } from '../../types/widgets.types'
import { WidgetsErrorBoundaryProps } from './WidgetsErrorBoundary.types'
import { ErrorBoundary } from './components'

export const WidgetsErrorBoundary: WidgetComponent<
  WidgetsErrorBoundaryProps
> = ({ children, debugName, orientation = 'vertical', ...widgetProps }) => {
  return (
    <ErrorBoundary
      debugName={debugName}
      orientation={orientation}
      {...widgetProps}
    >
      {children}
    </ErrorBoundary>
  )
}

WidgetsErrorBoundary.displayName = 'WidgetsErrorBoundary'
